import { statsBand, chatter } from "@/mocks/discussion";
import { toneSolid } from "./tones";

const VALUES = [
  {
    icon: "ri-chat-voice-line",
    title: "互动真实不注水",
    desc: "每位网友都可以自由表态、互相回复，讨论区公开透明，热度来自真实的围观与回应。",
  },
  {
    icon: "ri-line-chart-line",
    title: "上热榜快人一步",
    desc: "讨论越热烈的爆料越容易冲上 24h 热榜，让全网第一时间看到你的观点。",
  },
  {
    icon: "ri-hand-heart-line",
    title: "氛围友好有边界",
    desc: "我们倡导理性吃瓜、友善发言，并通过审核与举报机制守护讨论氛围的边界。",
  },
];

export default function CommunityVoice() {
  return (
    <section id="chatter" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        {/* 数据条 */}
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          {statsBand.map((s) => (
            <div key={s.label} className="rounded-2xl border border-background-200 bg-background-100 px-5 py-6 text-center">
              <p className="font-heading text-3xl text-primary-500 md:text-4xl">{s.value}</p>
              <p className="mt-1.5 text-xs text-foreground-600 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.1fr]">
          {/* 左边：品牌口碑 */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-primary-500">群众热议</p>
            <h2 className="section-title mt-2 text-2xl text-foreground-950 md:text-3xl">围观群众都爱来这里开麦</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              在爆料网，没有人需要端着。无论你是想安静围观、激情站队，还是分享第一手新鲜事，
              这里都有一群同样在线的网友等你来聊。轻松、真实、有人情味，是大家留下的共同评价。
            </p>

            <div className="mt-6 space-y-3">
              {VALUES.map((v) => (
                <div key={v.title} className="flex items-start gap-3 rounded-2xl bg-background-100 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-500 text-white">
                    <i className={`${v.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-950">{v.title}</p>
                    <p className="mt-1 text-[13px] leading-relaxed text-foreground-600">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 右边：实时口碑滚动 */}
          <div className="rounded-3xl border border-background-200 bg-background-100 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                <i className="ri-chat-heart-fill text-accent-500" aria-hidden="true"></i>
                吃瓜群众说
              </h3>
              <span className="text-[11px] text-foreground-400">最新围观动态</span>
            </div>

            <ul className="mt-4 space-y-3">
              {chatter.map((c, i) => (
                <li key={c.name} className="rounded-2xl bg-background-50 p-4 ring-1 ring-background-200">
                  <div className="flex items-center gap-3">
                    <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-bold ${toneSolid[c.tone]}`}>
                      {c.initial}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="flex items-center justify-between text-sm font-semibold text-foreground-900">
                        {c.name}
                        <span className="text-[11px] font-normal text-foreground-400">{c.time}</span>
                      </p>
                      <p className="mt-0.5 text-[13px] leading-relaxed text-foreground-600">{c.text}</p>
                    </div>
                    <span className="text-xs text-foreground-300" aria-hidden="true">
                      {i === 0 ? "🔥" : "👏"}
                    </span>
                  </div>
                </li>
              ))}
            </ul>

            <div className="mt-4 flex items-center justify-center gap-2 rounded-2xl bg-accent-500/10 py-3 text-center">
              <i className="ri-flashlight-fill text-accent-600" aria-hidden="true"></i>
              <span className="text-[13px] font-medium text-foreground-700">你也来一句？点开任意话题即可加入</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}